import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

interface TooltipButtonProps {
    icon?: React.ReactNode;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    style?: React.CSSProperties;
    title?: string;
    spanClassName?: string;
}

const TooltipButton: React.FC<TooltipButtonProps> = (props): JSX.Element => {
    const { icon, style, title, onClick, children, spanClassName } = props;

    // If we have children, wrap them in a span to make tooltip work
    if (children) {
        return (
            <Tooltip title={title} aria-label={title}>
                <span className={spanClassName}>{children}</span>
            </Tooltip>
        );
    }

    // Otherwise return the IconButton
    return (
        <Tooltip title={title} aria-label={title}>
            <IconButton color="inherit" edge="end" name={title} onClick={onClick} style={style}>
                {icon}
            </IconButton>
        </Tooltip>
    );
};

export default TooltipButton;
